import { useEffect } from 'react'
import { ResourceContextProvider } from 'react-admin'
import { NoOrders } from './NoOrders'
import { Box, Pagination } from '@mui/material'
import { useDigitalOrders } from '../hooks/useDigitalOrders'
import { DigitalOrdersList } from './DigitalOrdersList'
import PhysicalOrders from './PhysicalOrders'
import OrdersProvider from '../storage/OrdersProvider'

const styles = {
  container: {
    width: '100%',
    paddingTop: '30px',
    paddingBottom: '75px'
  }
}

export const Orders = () => {
  const {
    hasDigitalOrders,
    hasBatches,
    products,
    totalPages,
    pagination,
    setPage,
    fetchDigitalProducts
  } = useDigitalOrders()

  useEffect(() => {
    fetchDigitalProducts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination])

  return (
    <Box sx={styles.container}>
      {!hasDigitalOrders && !hasBatches && <NoOrders />}
      {(hasDigitalOrders || hasBatches) && (
        <OrdersProvider>
          <ResourceContextProvider value="physical-orders">
            <PhysicalOrders />
          </ResourceContextProvider>
        </OrdersProvider>
      )}
      {hasDigitalOrders && (
        <Box>
          <DigitalOrdersList products={products} />
          <Pagination
            page={pagination.page}
            count={totalPages}
            onChange={(_, page) => setPage(page)}
          />
        </Box>
      )}
    </Box>
  )
}
